export default "__VITE_ASSET__BZ_hzMlE__"